import "reflect-metadata";
import { Container } from "inversify";
import { ChatService } from "./chatService";
import { MessageSyncService } from "./messageSyncService";
import { ConversationFilterService } from "./conversationFilterService";
import { mount } from "./react-app/index";
import { RecommendedCountryCodeService } from "./recommendedCountryCodeService";
import { TemplatesStore } from "./react-app/templates-widget/TemplatesStore";
import { BlurMessageService } from "./blurMessageService";
import { BlockProfileImageService } from "./blockProfileImageService";
import { BlockMessagingService } from "@whatslly/instant-messaging/whatsapp/blockMessagingService";
import { IMUserStore } from "@whatslly/instant-messaging/IMUserStore";
import type { IStorage } from "@whatslly/commons/storage.constants";
import { InjectStorage } from "@whatslly/commons/storage.constants";
import { BackgroundStorage } from "@whatslly/commons/backgroundStorage";
import type { IBlockMessaging } from "./blockMessaging";
import { InjectBlockMessaging } from "./blockMessaging";
import type { IMessageEmitter } from "@whatslly/types/instant-messaging/messagesEmitter";
import { InjectMessageEmitter } from "@whatslly/types/instant-messaging/messagesEmitter";
import type { IVoiceVideoEmitter } from "@whatslly/types/instant-messaging/voiceVideoEmitter";
import { InjectVoiceVideoEmitter } from "@whatslly/types/instant-messaging/voiceVideoEmitter";
import { MessageScraper } from "./whatsapp/messageScraper";
import type { ContactModel, ModelType } from "@whatslly/types/instant-messaging/WhatsappTypes";
import { IMChannelType, InjectChannelType } from "./channelTypes";
import type { ISendMessage } from "./sendMessage";
import { InjectSendMessage } from "./sendMessage";
import { SendMessageService } from "./whatsapp/sendMessageService";
import { contentBackend } from "@whatslly/commons/contentBackend";
import type { MessagingBackend } from "@whatslly/commons/messagingBackend";
import type { ContentCommandsTypes } from "@whatslly/commons/contentCommands";
import type { WebScriptCommandsTypes } from "@whatslly/commons/webScriptCommands";
import { webScriptBackend } from "./webScriptBackend";
import { ContentBackendSymbol } from "@whatslly/types/contentBackendSymbol";
import { WebScriptBackendSymbol } from "@whatslly/types/webScriptBackendSymbol";
import type { IDOMInjectorService } from "./commons/IDOMInjectorService";
import { IDOMInjectorServiceSymbol } from "./commons/IDOMInjectorService";
import { DOMInjectorService } from "./react-app/DOMInjector/DOMInjectorService";
import type { IImTemplatesStore } from "@whatslly/instant-messaging/commons/IImTemplatesStore";
import { ImTemplatesStoreSymbol } from "@whatslly/instant-messaging/commons/IImTemplatesStore";
import { MessageFraudDetectorService } from "@whatslly/instant-messaging/messageFraudDetector";
import type { IKeywordInsights } from "@whatslly/instant-messaging/messageKeywordInsights";
import { InjectKeywordInsights } from "@whatslly/instant-messaging/messageKeywordInsights";
import { MessageKeywordInsightsService } from "@whatslly/instant-messaging/messageKeywordInsights";
import type { ISurveillance } from "@whatslly/instant-messaging/messageSurveillanceService";
import { InjectSurveillance, MessageSurveillanceService } from "@whatslly/instant-messaging/messageSurveillanceService";
import { ContactService } from "@whatslly/instant-messaging/contactService";
import { VoiceVideoRecordingService } from "./voiceVideoRecordingService";
import { VoiceVideoScraper } from "@whatslly/instant-messaging/whatsapp/voiceVideoScraper";
import { WaNotificationToneService } from "@whatslly/instant-messaging/whatsapp/waNotificationToneService";

export const container = new Container({ defaultScope: "Singleton", skipBaseClassChecks: true, autoBindInjectable: true });
container.bind<MessagingBackend<ContentCommandsTypes>>(ContentBackendSymbol).toConstantValue(contentBackend);
container.bind<MessagingBackend<WebScriptCommandsTypes>>(WebScriptBackendSymbol).toConstantValue(webScriptBackend);
container.bind(ChatService).toSelf();
container.bind(MessageSyncService).toSelf();
container.bind(ConversationFilterService).toSelf();
container.bind(BlurMessageService).toSelf();
container.bind(BlockProfileImageService).toSelf();
container.bind(RecommendedCountryCodeService).toSelf();
container.bind(IMUserStore).toSelf();
container.bind(ContactService).toSelf();
container.bind<IBlockMessaging>(InjectBlockMessaging).to(BlockMessagingService);
container.bind<ISendMessage>(InjectSendMessage).to(SendMessageService);
container.bind<IStorage>(InjectStorage).to(BackgroundStorage);
container.bind<IMChannelType>(InjectChannelType).toConstantValue(IMChannelType.whatsapp);
container.bind<IMessageEmitter<ContactModel, ModelType>>(InjectMessageEmitter).toConstantValue(MessageScraper);
container.bind<IVoiceVideoEmitter>(InjectVoiceVideoEmitter).toConstantValue(VoiceVideoScraper);
container.bind<IDOMInjectorService>(IDOMInjectorServiceSymbol).to(DOMInjectorService);
container.bind<IImTemplatesStore>(ImTemplatesStoreSymbol).to(TemplatesStore);
container.bind<MessageFraudDetectorService>(MessageFraudDetectorService).to(MessageFraudDetectorService);
container.bind<IKeywordInsights>(InjectKeywordInsights).to(MessageKeywordInsightsService);
container.bind<ISurveillance>(InjectSurveillance).to(MessageSurveillanceService);
container.bind(VoiceVideoRecordingService).toSelf();
container.bind(WaNotificationToneService).toSelf();
mount(container);
